<template>
    <AuthenticatedLayout
        :title="__('Thank you')"
    >
    <div class="max-w-screen-xl mx-auto">
        <div class="grid md:grid-cols-3 gap-3">
            <div class="bg-white shadow-md rounded-md md:p-6 p-3 col-span-2">
                <Heading
                    :label="__('Thank you for your order!')"
                    class="text-center"
                />
                <div class="text-center">
                    <p>{{__('Your payment was successful and the orders were accepted for processing.')}}</p>
                    <p>{{__('Within a few days, your order should be shipped to the address you provided when placing the order.')}}</p>

                    <SvgIcon
                        name="cash"
                        class="text-red-700 w-24 h-24 mx-auto"
                    />
                </div>
            </div>
            <div class="bg-white shadow-md rounded-md md:p-6 p-3">
                <img src="/img/cms/thank-you.svg" class="w-full" />
            </div>
        </div>
    </div>
    </AuthenticatedLayout>
</template>

<script>
import AuthenticatedLayout from '@/Layouts/Authenticated';
import SvgIcon from 'UI/SvgIcon';
import Heading from 'COMP/Heading';
import CustomSelect from 'UI/CustomSelect';
import InputLabel from 'UI/InputLabel';

import Button from 'UI/Button';

export default {
    components: {
        AuthenticatedLayout,
        SvgIcon,
        Heading,
        CustomSelect,
        InputLabel,
        Button,
    },
    props: {
        auth: Object,
        loggedin: Boolean
    },
    setup(props) {



        return {


        }
    },



}
</script>
